export var scopeTag = {
  key: 'source',
  value: '@hCaptcha/react'
};
export var breadcrumbMessages = {
  mounted: 'hCaptcha component mounted',
  expired: 'hCaptcha expired',
  unmounted: 'hCaptcha component unmounted',
  reset: 'hCaptcha reset',
  removed: 'hCaptcha removed'
};